import type { Partner } from "@/models";

/**
 * Whether WEA should enforce the FDA-labeling / starting-weight + 5% exclusion
 * for current GLP-1 users. Missing config defaults to enabled (safe).
 */
export const isGlp1FdaLabelingEnforced = (
  partnerInfo?: Partner | null,
): boolean => partnerInfo?.configs?.ENFORCE_GLP1_FDA_LABELING_ELIGIBILITY ?? true;
